module.exports = __webpack_public_path__ + "media/images/stripe/blue-on-light@2x-11f0b424947f9936d3a6006917d9f4d3.png";